import { gh, isExecute, vueDefineComponent } from '@syncfusion/ej2-vue-base';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
export let ImagesDirective = vueDefineComponent({
    inject: { custom: { default: null } },
    render(createElement) {
        if (!isExecute) {
            let h = !isExecute ? gh : createElement;
            let slots = null;
            if (!isNullOrUndefined(this.$slots.default)) {
                slots = !isExecute ? this.$slots.default() : this.$slots.default;
            }
            return h('div', { class: 'e-directive' }, slots);
        }
        return;
    },
    updated() {
        if (!isExecute && this.custom) {
            this.custom();
        }
    },
    methods: {
        getTag() {
            return 'e-images';
        }
    }
});
export const ImagesPlugin = {
    name: 'e-images',
    install(Vue) {
        Vue.component(ImagesPlugin.name, ImagesDirective);
    }
};
export let ImageDirective = vueDefineComponent({
    render() {
        return;
    },
    methods: {
        getTag() {
            return 'e-image';
        }
    }
});
export const ImagePlugin = {
    name: 'e-image',
    install(Vue) {
        Vue.component(ImagePlugin.name, ImageDirective);
    }
};
